import { useEffect, useState } from 'react';
import { getThemeMode, setThemeMode, type ThemeMode } from '@/lib/theme';

export function ThemeToggle({ compact = false }: { compact?: boolean }) {
  const [mode, setMode] = useState<ThemeMode>(getThemeMode());

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail as { mode: ThemeMode };
      setMode(detail.mode);
    };
    window.addEventListener('kt:theme-change', handler);
    return () => window.removeEventListener('kt:theme-change', handler);
  }, []);

  const choose = (m: ThemeMode) => () => setThemeMode(m);

  if (compact) {
    return (
      <button
        type="button"
        className="btn btn-icon btn-sm btn-active-light-primary"
        title={`Tema: ${mode}`}
        onClick={choose(mode === 'dark' ? 'light' : 'dark')}
      >
        <i className={`bi bi-${mode === 'dark' ? 'sun-fill' : 'moon-stars-fill'} fs-5`}></i>
      </button>
    );
  }

  return (
    <div className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-semibold py-4 fs-base w-175px" data-kt-menu="true">
      <div className="menu-item px-3 my-0">
        <a href="#" className={`menu-link px-3 py-2 ${mode === 'light' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); choose('light')(); }}>
          <span className="menu-icon"><i className="bi bi-sun-fill fs-3"></i></span>
          <span className="menu-title">Light</span>
        </a>
      </div>
      <div className="menu-item px-3 my-0">
        <a href="#" className={`menu-link px-3 py-2 ${mode === 'dark' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); choose('dark')(); }}>
          <span className="menu-icon"><i className="bi bi-moon-stars-fill fs-3"></i></span>
          <span className="menu-title">Dark</span>
        </a>
      </div>
      <div className="menu-item px-3 my-0">
        <a href="#" className={`menu-link px-3 py-2 ${mode === 'system' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); choose('system')(); }}>
          <span className="menu-icon"><i className="bi bi-display fs-3"></i></span>
          <span className="menu-title">Sistema</span>
        </a>
      </div>
    </div>
  );
}

export default ThemeToggle;
